import { PortalAppContext } from '@tangocard/portal-app-context'
import { MicroFrontendApp } from './types'

const appLoader = `
<div 
  id="app-loader"
  class="fixed w-full h-2 bg-surface-sunken overflow-hidden"
  role="progressbar"
  aria-label="Loading"
  aria-valuemin="0"
  aria-valuemax="100"
>
  <div 
    class="h-full w-full bg-primary animate-[indeterminate_1.5s_infinite_ease-in-out]"
  ></div>
</div>
`

const createSingleSpaRouterLayout = (content: {
  sideNav?: string
  main: string
  signupApp: string
}) => `
<single-spa-router>
    <route path="/vue/#/signup">
        ${content.signupApp}
    </route>
    
    <route default>
      <div id="app-container">
          ${content.sideNav ?? ''}
          
          ${content.sideNav ? appLoader : ''}
          
          <div id="app-page-container">
              <main id="app-main-content">
                  ${content.main}
              </main>
          </div>
      </div>
    </route>
</single-spa-router>
`

const createSingleSpaApp = (name: string) =>
  `<application name="${name}"></application>`

export const createLayout = ({ authService }: PortalAppContext) => {
  const portalVueApp = createSingleSpaApp(MicroFrontendApp.LegacyVueApp)

  if (!authService.isAuthenticated()) {
    return createSingleSpaRouterLayout({
      signupApp: portalVueApp,
      main: createSingleSpaApp(MicroFrontendApp.PortalContent),
    })
  }

  return createSingleSpaRouterLayout({
    signupApp: portalVueApp,
    sideNav: createSingleSpaApp(MicroFrontendApp.SideNav),
    main: `
      <route default>
        ${createSingleSpaApp(MicroFrontendApp.PortalContent)}
        <div class="h-0">
           ${portalVueApp}
        </div>
      </route>
      <route path="/vue">
        ${portalVueApp}
      </route>
    `,
  })
}
